import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { AppConfigArea, AppConfigKey, FilterDefinitionType } from 'enums';
import { TranslationNamespace } from 'i18n';
import { AppConfigFilters, FilterDefinition } from 'types';
import { appConfigUtils } from 'utils';

import { ConfigsPageTab } from '../ConfigsPageTab';

export const P2PProvidersCommonTab: React.FC = () => {
  const { t } = useTranslation(TranslationNamespace.Admin, {
    keyPrefix: 'features.configs',
  });

  const additionalFilters: FilterDefinition<AppConfigFilters>[] = useMemo(
    () => [
      {
        label: t('fields.key'),
        name: 'key',
        type: FilterDefinitionType.Enum,
        enum: [AppConfigKey.AvailableP2PProviderTypes],
        getDisplayName: appConfigUtils.getKeyLabel,
      },
    ],
    [t],
  );

  return (
    <ConfigsPageTab
      area={AppConfigArea.P2PProvidersCommon}
      additionalFilters={additionalFilters}
    />
  );
};
